import { render, staticRenderFns } from "./scan-code.vue?vue&type=template&id=b14af6fa&scoped=true"
import script from "./scan-code.vue?vue&type=script&lang=js"
export * from "./scan-code.vue?vue&type=script&lang=js"
import style0 from "./scan-code.vue?vue&type=style&index=0&id=b14af6fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14af6fa",
  null
  
)

export default component.exports